import { BaseRoute } from 'src/routes/BaseRoute'
import { ActionCreator } from '@sendoutcards/core'

export const openRoute = ActionCreator(
  'OPEN_ROUTE',
  (route: BaseRoute, args: { [key: string]: string | undefined }) => ({
    route,
    args,
  }),
)
